/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { makeStyles } from '@mui/styles';
import Paper from 'apollo-react/components/Paper';
import ChevronRight from 'apollo-react-icons/ChevronRight';
import React, { useState } from 'react';

import { CONTAINERS_LABELS } from '../constants/report-designer.constants';

const useStyles = makeStyles({
  root: {
    padding: '0 4px',
    marginBottom: 12,
    userSelect: 'none',
  },
  paper: {
    padding: 10,
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '& *': {
      marginTop: 0,
      marginBottom: 0,
    },
    '&:hover': {
      color: '#0557d5',
    },
  },
  headerText: {
    paddingLeft: 4,
    fontWeight: 600,
  },
});

const ExpandablePanel = ({ children, controlType }) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(true);

  const handleClick = (e) => {
    e.stopPropagation();
    setIsOpen((prev) => !prev);
  };

  const label = CONTAINERS_LABELS[controlType] || controlType;

  return (
    <div className={classes.root}>
      <Paper elevation={1} className={classes.paper}>
        <div onClick={handleClick} className={classes.headerContainer}>
          <ChevronRight
            fontSize="small"
            style={{ transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)' }}
          />
          <p className={classes.headerText}>{label}</p>
        </div>
        {isOpen && children}
      </Paper>
    </div>
  );
};

export default ExpandablePanel;
